/**
 * 점주 콘솔 세션 API.
 *
 * 기존 관리자 api client 를 재사용한다:
 * - Authorization 토큰 자동 첨부
 * - 401 응답 시 토큰 제거 + /login 리다이렉트 (기존 관리자 정책 그대로)
 */
import api from '../../api/client';

export async function fetchOwnerConsoleSession(storeId) {
  const res = await api.get('/owner-console/session', {
    params: storeId ? { storeId } : undefined,
  });
  return res.data;
}
